import { HeaderMenuItem, HeaderNavigation } from '@carbon/react';
import { useSelector } from "react-redux";
import { selectWrittenNavigationItems } from "../../../features/application/applicationSlice.js";
import { useTranslation } from "react-i18next";

const NavigationItems = ({ onItemClick, highlightElement, onReportClick, reportLoading = false }) => {
    const navItems = useSelector(selectWrittenNavigationItems);
    const { t } = useTranslation();

    return (
        <HeaderNavigation aria-label={t("app.subtitle")}>
            {navItems.map((item) => {
                if (!item.active) return null;
                return (
                    <HeaderMenuItem
                        key={item.name}
                        className="pointer"
                        onClick={() => onItemClick(item)}
                    >
                        {highlightElement(item.name, t(item.translationKey))}
                    </HeaderMenuItem>
                );
            })}
            {onReportClick && (
                <HeaderMenuItem
                    className="pointer"
                    aria-label={t("header.reportAction")}
                    disabled={reportLoading}
                    onClick={onReportClick}>
                    {reportLoading ? t("header.reportGenerating") : t("header.reportAction")}
                </HeaderMenuItem>
            )}
        </HeaderNavigation>
    );
};

export default NavigationItems;
